<template>
  <div class="tag-info">
    <div class="tag-info__inner">
      <h5 class="tag-info__title">Edit Marker</h5>
      <div class="tag-info__col">
        <!-- Font size -->
        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">Font Size</label>
          <input
            class="form-control"
            type="number"
            step="0.01"
            v-model.number="value.marker.fontSize"
          />
        </div>

        <!-- Padding -->
        <div
          v-if="value.marker && value.marker.padding"
          class="tag-info__block tag-info__block--inline"
        >
          <label style="flex-shrink: 0; margin-right: 10px;">Padding</label>
          <div class="group-block__inputs">
            <div class="group-block__input-wrapper">
              <label>Top</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.marker.padding[0]"
              />
            </div>
            <div class="group-block__input-wrapper">
              <label>Bottom</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.marker.padding[2]"
              />
            </div>
            <div class="group-block__input-wrapper">
              <label>Left</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.marker.padding[3]"
              />
            </div>
            <div class="group-block__input-wrapper">
              <label>Right</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.marker.padding[1]"
              />
            </div>
          </div>
        </div>

        <!-- Text colour -->
        <div class="tag-info__block">
          <div class="inline-label">
            <label>Text Colour</label>
            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.marker.textColour }"
                @click="toggleColourWidget('textColour')"
              ></div>
            </div>
          </div>

          <verte
            v-if="colourWidget === 'textColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.marker.textColour"
          />
        </div>

        <!-- Background colour -->
        <div class="tag-info__block">
          <div class="inline-label">
            <label>Background Colour</label>
            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.marker.backgroundColour }"
                @click="toggleColourWidget('backgroundColour')"
              ></div>
            </div>
          </div>

          <verte
            v-if="colourWidget === 'backgroundColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.marker.backgroundColour"
          />
        </div>

        <!-- Tail position / height -->
        <div class="tag-info__block">
          <label>Tail Position</label>
          <select v-model="value.marker.tailPosition" class="form-control">
            <option value="none">No Tail</option>
            <option value="bottom-left">Bottom Left</option>
            <option value="bottom-center">Bottom Center</option>
            <option value="bottom-right">Bottom Right</option>
            <option value="top-left">Top Left</option>
            <option value="top-center">Top Center</option>
            <option value="top-right">Top Right</option>
            <option value="left-center">Left Center</option>
            <option value="right-center">Right Center</option>
          </select>
        </div>

        <div class="tag-info__block">
          <label>Tail Height</label>
          <input
            class="form-control"
            type="number"
            v-model.number="value.marker.tailHeight"
          />
        </div>

        <!-- Rotation -->
        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">Rotation</label>
          <input
            class="form-control"
            type="number"
            v-model.number="value.marker.rotation"
          />
        </div>

        <!-- Box shadow -->
        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">Box Shadow</label>
          <input
            class="form-control"
            type="checkbox"
            v-model.number="value.marker.boxShadow"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  props: ["value"],

  components: {
    Verte
  },

  data() {
    return {
      colourWidget: ""
    };
  },

  methods: {
    toggleColourWidget(key) {
      this.colourWidget = this.colourWidget === key ? "" : key;
    },

    reset() {
      if (window.confirm("Are you sure you want to reset the marker styles?")) {
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";

.tag-info {
  background: rgba(255, 255, 255, 0.95);
  padding: 15px;
  pointer-events: all;
  width: 100%;
  height: 100%;
  transition: all 300ms ease-in-out;
  z-index: 100;

  &__inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    width: 100%;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 10px;
  }

  &__col {
    display: flex;
    flex-direction: column;
    margin: 0 0 5px 0;
    width: 100%;
  }

  &__block {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    label {
      font-size: 0.85em;
      margin: 0;
      text-transform: capitalize;
    }

    &--inline {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      input {
        width: calc(100% - 20px);
      }
    }
  }
}

.inline-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  label {
    margin: 0;
    font-size: 0.85em;
    flex: 1;
  }
}

.colour-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-colour {
  border: 1px solid #111;
  border-radius: 3px;
  width: 44px;
  height: 22px;
}

.colour-picker {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
}

.group-block__inputs {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  input {
    width: 100%;
  }

  label {
    font-size: 0.75em;
    text-transform: none;
  }
}
</style>
